<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="等级名称：" prop="name">
          <el-input v-model="form.name" placeholder="请输入等级名称" />
        </el-form-item>
        <el-form-item label="等级学分标准：" prop="endCredit">
          <el-input v-model="form.startCredit" placeholder="最低学分" style="width: 110px" /> - <el-input v-model="form.endCredit" placeholder="最高学分" style="width: 110px" />
        </el-form-item>
        <el-form-item label="等级头衔：" prop="titleLevel">
          <div class="flexs">
            <imageUpload v-model="form.titleLevel" width="42" height="42" />
            <!-- <span class="hint hint1">限制上传1张<br />建议尺寸240x300像素以上</span> -->
          </div>
        </el-form-item>
        <el-form-item label="等级证书：" prop="certificateLevel">
          <div class="flexs">
            <imageUpload v-model="form.certificateLevel" width="42" height="42" />
            <!-- <span class="hint hint1">限制上传1张<br />建议尺寸750x750像素以上</span> -->
          </div>
        </el-form-item>
        <el-form-item label="星级等级：" class="width100">
          <el-input v-model="form.standardLevel" placeholder="请输入每加好多学分得一颗星" />
        </el-form-item>
        <el-form-item label="状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch> {{form.state?'启用':'禁用'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import courseCreditLevelApi from '@/api/course/courseCreditLevel'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    name: null,
    startCredit: null,
    endCredit: null,
    titleLevel: null,
    certificateLevel: null,
    standardLevel: null,
    state: 0,
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        endCredit: [{ required: true, message: '请输入等级学分标准', trigger: 'blur' }],
        titleLevel: [{ required: true, message: '请上传等级头衔', trigger: 'change' }],
        certificateLevel: [{ required: true, message: '请上传等级证书', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseCreditLevelApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseCreditLevelApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
